import React from 'react'
import me from './images/me.jpg'
import './css/Home.css'
import { Link } from 'react-router-dom'

function Home() {
  return (
    <div>
        <section id='hero'>
            <div className="container">
                <div className="left">
                    <p className="subheading">I'm SUBHADIP MANDAL</p>
                    <h2 className="heading">
                        <div className="wrapper"><span>Developer</span></div><br/>
                        <div className="wrapper"><span>Student</span></div><br/>
                        <div className="wrapper"><span>Front-end Web Developer</span></div>
                    </h2>
                    <p className="desc">
                        You might see me jumping, climbing, Building and stopping trains.
                        But nobody pays me a dime for that work.
                        That's why I am learning and mastering web development.
                        I will not stop until I become the web development hero.
                        <br/><br/>
                        I am fluent in classics like <em>C, Java, Javascript and Python.</em>
                    </p>
                    <div className="buttons">
                        <Link to="projects" className="primary-btn">See My Works</Link>
                    </div>
                </div>
                <div className="right">
                    <img src={me} alt="profilephoto" />
                </div>
            </div>
        </section>
    </div>
  )
}

export default Home